import { create } from 'zustand';

export type ToastSeverity = 'success' | 'error';

interface ToastState {
  message: string;
  severity: ToastSeverity;
}

interface ToastStore {
  toast: ToastState | null;
  showToast: (message: string, severity: ToastSeverity) => void;
  hideToast: () => void;
}

export const useToastStore = create<ToastStore>((set) => ({
  toast: null,
  showToast: (message, severity) => set({ toast: { message, severity } }),
  hideToast: () => set({ toast: null }),
}));
